<template>
  <footer>
    <section>
      <div id="how2get2us">
        <UiBg class="bg" src="/static/image/video_bg.jpg" />
        <div class="overlay"></div>
        <div class="video_how2get2us">
          <a
            href="/static/video/travel.mp4"
            class="video-service"
            @click.prevent="showVideo()"
          >
            <UiAnim tag="h2">Как к нам проехать</UiAnim>
            <UiAnim tag="span" :delay="2" class="video_button"></UiAnim>
          </a>
        </div>
      </div>
      <div id="yamap_box">
        <ClientOnly><BlockYaMap /></ClientOnly>
        <div id="yamap_overlay"></div>
      </div>
      <span class="clr"></span>
    </section>

    <div id="footer">
      <div class="wrapper">
        <p>
          <span>&copy; 2019-{{ year }}</span
          >&nbsp;<span>&middot; Установочный центр «BGT» &middot;</span
          >&nbsp;<NuxtLink to="/policy">Политика конфиденциальности</NuxtLink>
        </p>
      </div>
    </div>
  </footer>
  <ModalMVideo
    src="travel"
    :vertical="true"
    v-if="video"
    @closed="video = false"
  />
</template>

<script setup>
const { isModal, mVideo } = useModal();
const video = ref();
const d = new Date();
const year = d.getFullYear();
const showVideo = () => {
  if (!isModal) return mVideo("travel", true);
  video.value = true;
};
</script>
